import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { CTA } from './ui/Button';
const before = ['Improvisar entrevistas', 'Dudar constantemente', 'Sentirte insegura', 'Perder tiempo organizando todo', 'No saber cómo intervenir', 'Sentir ansiedad con cada caso nuevo'];
const after = ['Más claridad clínica', 'Más organización', 'Más seguridad profesional', 'Más estructura', 'Más herramientas prácticas', 'Mucha menos improvisación'];
export function BeforeAfterSection() {
  return <section className="py-16 bg-white" data-id="element-12">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-13">
        <div className="text-center mb-10" data-id="element-14">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 uppercase tracking-tight" data-id="element-15">
            Tu práctica clínica, transformada
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-16">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-rose-50/50 rounded-3xl p-8 border border-rose-100 relative overflow-hidden" data-id="element-17">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-rose-400" data-id="element-18" />
            <h3 className="font-bold text-slate-500 uppercase tracking-widest mb-6 text-sm" data-id="element-19">
              Antes de este material
            </h3>
            <ul className="space-y-4" data-id="element-20">
              {before.map((b, i) => <li key={i} className="flex items-start gap-3" data-id="element-21">
                  <XCircle className="w-5 h-5 text-rose-400 shrink-0 mt-0.5" data-id="element-22" />
                  <span className="text-slate-600 font-medium" data-id="element-23">{b}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-pink-50/50 rounded-3xl p-8 border border-pink-100 relative overflow-hidden" data-id="element-24">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-pink-500" data-id="element-25" />
            <h3 className="font-bold text-pink-700 uppercase tracking-widest mb-6 text-sm" data-id="element-26">
              Después de este sistema
            </h3>
            <ul className="space-y-4" data-id="element-27">
              {after.map((b, i) => <li key={i} className="flex items-start gap-3" data-id="element-28">
                  <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-29" />
                  <span className="text-slate-800 font-semibold" data-id="element-30">{b}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-31">
          <CTA scrollTo="oferta" label="QUIERO EMPEZAR CLÍNICA CON MÁS SEGURIDAD" data-id="element-32" />
        </div>
      </div>
    </section>;
}